import api from "./api.service";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static media(startAt = 0, numberToGet = 10, searchTerm = -1, tags = -1) {
    let commaDelimTags = -1;
    if (tags.length > 0) {
      commaDelimTags = tags.join(",");
    }
    return this.apiRequest(
      API_SUFFIX +
        "/api/media/" +
        startAt +
        "/" +
        numberToGet +
        "/" +
        searchTerm +
        "/" +
        commaDelimTags,
      {},
      "GET"
    );
  }

  static getUsersPublicMedia(userId, startAt = 0, numberToGet = 10) {
    return this.apiRequest(
      API_SUFFIX +
        "/api/media/UserMedia" +
        userId +
        "/" +
        startAt +
        "/" +
        numberToGet,
      {},
      "GET"
    );
  }

  static mediaItem(uuidId) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/MediaItem/" + uuidId,
      {},
      "GET"
    );
  }

  static myMedia(startAt = 0, numberToGet = 10) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/MyMedia/" + startAt + "/" + numberToGet,
      {},
      "GET"
    );
  }

  static myUnpostedMedia(startAt = 0, numberToGet = 10) {
    return this.apiRequest(
      `${API_SUFFIX}/api/media/myunpostedmedia/${startAt}/${numberToGet}`,
      {},
      "GET"
    );
  }

  static mediaTags() {
    return this.apiRequest(API_SUFFIX + "/api/alltags", {}, "GET");
  }

  static favouritedMedia() {
    return this.apiRequest(API_SUFFIX + "/api/media/favourites", {}, "GET");
  }

  static toggleFavouriteMedia(mediaId) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/favourite/" + mediaId,
      {},
      "POST"
    );
  }

  static editMedia(data, mediaId) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/Edit/" + mediaId,
      data,
      "PATCH"
    );
  }

  static uploadMedia(formData) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/upload",
      formData,
      "POST",
      true
    );
  }

  static deleteMedia(mediaId) {
    return this.apiUpload(
      API_SUFFIX + "/api/media/Delete/" + mediaId,
      {},
      "POST"
    );
  }

  static getUsersFavouritedScenarios(userId) {
    return this.apiRequest(
      API_SUFFIX + "/api/user/" + userId + "/media/favourites",
      {},
      "GET"
    );
  }

  static downloadMedia(mediaId) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/Download/" + mediaId,
      {},
      "GET"
    );
  }

  static getAllPending() {
    return this.apiRequest(
      API_SUFFIX + "/api/media/MediaPendingApproval",
      {},
      "GET"
    );
  }

  static approveMedia(mediaUuid) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/AdminApproveMedia/" + mediaUuid
    );
  }

  static rejectMedia(mediaUuid, reason) {
    return this.apiRequest(
      API_SUFFIX + "/api/media/AdminRejectMedia/" + mediaUuid,
      reason
    );
  }
}
